import { render, staticRenderFns } from "./actionList.vue?vue&type=template&id=2f18b436"
import script from "./actionList.vue?vue&type=script&lang=js"
export * from "./actionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports